/**
 * Design system du legacy : variables CSS injectées depuis design-tokens.json
 * (source unique extraite), image de fond webp appliquée au thème sombre avec
 * son voile dégradé d'origine. Sombre par défaut, toggle NON persisté (acté).
 */
import designTokens from "../data/design-tokens.json";
import backgroundUrl from "../assets/background.webp";

function varsBlock(vars: Record<string, string>): string {
  return Object.entries(vars)
    .map(([k, v]) => `${k}:${v};`)
    .join("");
}

export function installTheme(): void {
  const { themes } = designTokens;
  const style = document.createElement("style");
  style.id = "design-tokens";
  style.textContent = [
    `:root,[data-theme=light]{${varsBlock(themes.light)}}`,
    `[data-theme=dark]{${varsBlock(themes.dark)}}`,
    // a11y : le tertiaire legacy (#888780) tombe à ~4:1 sur la carte sombre
    // (< AA 4.5:1) ; on l'éclaircit en sombre uniquement. Override APRÈS le bloc
    // dark (même spécificité → la règle la plus tardive gagne), sans toucher au
    // JSON généré (règle « src/data jamais édité à la main »).
    `[data-theme=dark]{--color-text-tertiary:#a8a79f}`,
    // fond legacy : dégradé + image, thème sombre uniquement (extraction)
    `[data-theme=dark] body{background-color:#21201e;background-image:linear-gradient(rgba(33,32,30,.55),rgba(33,32,30,.32) 45%,rgba(33,32,30,.16)),url("${backgroundUrl}");background-size:cover;background-attachment:fixed;background-position:center top}`,
  ].join("\n");
  document.head.appendChild(style);
  if (!document.documentElement.dataset.theme) document.documentElement.dataset.theme = "dark";
}

export function toggleTheme(): string {
  const root = document.documentElement;
  root.dataset.theme = root.dataset.theme === "dark" ? "light" : "dark";
  return root.dataset.theme;
}
